export enum ECropperImageType {
    circle_350 = 1,     // ? Use for circle Avatars
    rectangle_350,      // ? Use for Uploaded Contents and user wallpapers
    rectangle_free,     // ? Use for Book Images
    wide_rectangle_445  // ? Use for onboarding banner
}
